import type { FuenteDeLaPropuesta as Fuente } from "@/lib/rellenoConIa";

/**
 * De qué documento del expediente dice la IA que salió lo que propuso.
 *
 * ES UNA DECLARACIÓN DEL MODELO, NO UNA PRUEBA. El esquema le impide inventar un
 * documento, pero no elegir el equivocado, así que el texto no dice "según" ni
 * "extraído de": dice qué documento indicó y pide revisarlo antes de aceptar.
 *
 * Solo se dibuja mientras la propuesta está en revisión; la fuente no se guarda
 * con los datos, y por eso este componente no sabe nada de dónde sale. Un
 * servidor más viejo que el webapp no manda la clave: se lee igual que `null`.
 */
export function FuenteDeLaPropuesta({ fuente }: { fuente: Fuente | null }) {
  return (
    <span
      className="text-caption text-ink-hint"
      title="Documento que indicó la IA; revísalo antes de aceptar"
    >
      {!fuente ? "Fuente no indicada" : `Fuente: ${fuente.tipo} · ${fuente.archivo}`}
    </span>
  );
}
